import type { StringMap } from 'corgi-types';

import type { Replace, Translate } from '../../providers/LocaleProvider';
import type { ErrorMessage } from '../../types/error';
import { getRegisterErrorMessage } from '../error-handlers/register';
import { isObject } from '../object';

type TranslateOptions = StringMap<string>;

interface GetTranslatedErrorMessageOptions {
  error: unknown;
  replace: Replace;
  translate: Translate;
  translateOptions: StringMap<string>;
  defaultError?: string;
}

export const getErrorMessageTranslator =
  (translate: (key: string, options?: TranslateOptions) => string, options?: TranslateOptions) =>
  (msg: ErrorMessage) => (!msg.translated ? translate(msg.message, options) : msg.message);

export const getTranslatedErrorMessage = ({
  error,
  replace,
  translate,
  translateOptions,
  defaultError,
}: GetTranslatedErrorMessageOptions) => {
  const {
    errorMessage: { withOptions, ...restErrorMessage },
    hasGqlErrorExtensions,
  } = getRegisterErrorMessage(error, defaultError);
  const translateFn = withOptions ? replace.t : translate;
  const translateErrorMessage = getErrorMessageTranslator(
    translateFn,
    withOptions && { ...translateOptions }
  );
  const translatedErrorMessage = translateErrorMessage(restErrorMessage);

  return { translatedErrorMessage, hasGqlErrorExtensions };
};

export const isErrorMessage = (error: unknown): error is ErrorMessage =>
  isObject(error) &&
  ['message', 'translated', 'timestamp'].every(key => Object.hasOwnProperty.call(error, key));
